module.exports = __webpack_public_path__ + "~@/assets/img/1_trace.999bb560.png";